import request from '@/utils/request'

export function getAll(page_size, currentPage, referrals, branch) {
  return request({
    url: 'referrals/getReferrals/' + page_size +'/' +referrals+'/'+branch + '?page=' + currentPage,
    method: 'get'
  })
}

export function deleteData(id) {
  return request({
    url: 'referrals/destroy/' + id,
    method: 'delete'
  });
}